/**
 * Retrieves the value of a public environment variable prefixed with `NEXT_PUBLIC_`.
 *
 * @param key - The key of the environment variable (without the `NEXT_PUBLIC_` prefix).
 * @param fallback - An optional fallback value to return if the environment variable is not set.
 * @returns The value of the environment variable if it exists, otherwise the fallback value or `undefined`.
 */
export const getPublicEnv = (key, fallback) => {
    return getEnv(`NEXT_PUBLIC_${key}`, fallback);
};
/**
 * Filters the provided environment variables to include only those
 * whose keys start with the prefix `NEXT_PUBLIC_`.
 *
 * @param env - A record containing environment variables as key-value pairs.
 * @returns A new record containing only the environment variables
 *          with keys that start with `NEXT_PUBLIC_`.
 */
export const filterPublicEnv = (env) => {
    const result = {};
    for (const key in env) {
        if (key.startsWith('NEXT_PUBLIC_')) {
            result[key] = env[key];
        }
    }
    return result;
};
/**
 * Retrieves the value of an environment variable by its key.
 * It first checks the `process.env` object for server-side resolution.
 * If not found, it checks the `globalThis.env` object for both server-side
 * and client-side resolution. If the key is not found in either, it returns
 * the provided fallback value or `undefined`.
 *
 * @param key - The name of the environment variable to retrieve.
 * @param fallback - An optional fallback value to return if the variable is not found.
 * @returns The value of the environment variable, the fallback value, or `undefined`.
 */
export const getEnv = (key, fallback) => {
    // local env resolution server-sided  
    if (process.env[key] !== undefined) {
        return process.env[key];
    }
    // env resolution server- and client-sided
    // @ts-ignore
    if (globalThis.env && globalThis.env[key] !== undefined) {
        return globalThis.env[key];
    }
    return fallback;
};
